import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=032c1540"
import script from "./HoverButton.vue?vue&type=script&lang=js"
export * from "./HoverButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032c1540')) {
      api.createRecord('032c1540', component.options)
    } else {
      api.reload('032c1540', component.options)
    }
    module.hot.accept("./HoverButton.vue?vue&type=template&id=032c1540", function () {
      api.rerender('032c1540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/HoverButton.vue"
export default component.exports